<template>
  <v-btn
    v-if="!dialog"
    color="black"
    dark
    @click="dialog = true"
    block
  >
    localizaciones
  </v-btn>
  <v-row justify="center" v-else>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <v-btn
          color="orange"
          dark
          v-bind="attrs"
          v-on="on"
        >
          css
        </v-btn>
      </template-->
      <v-card style="background-color: #CCCCCC;">
        <v-toolbar
          dark
          color="primary"
          elevation="0"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Localizaciones
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-row
          style="padding: 20px;"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <div
              v-for="(item, index) of values"
              :key="index"
            >
              <v-btn
                @click="handleEdit(item)"
                block
                text
                :color="item.Color"
                :disabled="editedItem ? true : false"
              >
                {{ item.Name.es || item.Name.en || item.ID }}
              </v-btn>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            v-if="!editedItem"
            style="padding: 10px;"
          >
            <v-btn
              @click="handleAdd"
              color="primary"
              block
            >
              añadir
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            v-if="editedItem"
            style="padding: 10px;"
          >
            <v-row
            >
              <v-col
                cols="12"
                sm="12"
                style="padding: 10px 20px;"
              >
                <translate
                  v-model="editedItem.Name"
                  :languages="languages"
                  :label="$t('booking.name', locale)"
                  @input="handleChangeIsModified"
                  type="text"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <action-buttons
                  :id="editedItem.ID"
                  :onDeleteItem="handleDelete"
                  :onSaveItem="handleSave"
                  :onClose="() => { editedItem = null }"
                  :locale="locale"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const defaultItem = {
  Name: { es: '' }
}
import apiService from '@/services/api'
import Translate from '@/components/Translate'
import ActionButtons from '@/components/ActionButtons'
export default {
  components: {
    Translate,
    ActionButtons,
  },
  props: {
    locale: {
      type: String,
      default: 'es',
    },
    id: {
      type: String,
      required: true,
    },
    workspaceID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    values: [],
    editedItem: null,
    totemTactilIcons: null,
  }),
  computed: {
    languages () {
      return ['es', 'en', 'de', 'fr', 'pt']
    },
  },
  watch: {
    dialog (v) {
      if (v) this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleAdd () {
      this.editedItem = JSON.parse(JSON.stringify(defaultItem))
    },
    handleEdit (v) {
      this.editedItem = JSON.parse(JSON.stringify(v))
    },
    handleDelete (v) {
      apiService.deleteItem('dviewcontent', `v1/system/activity-barcelo-01/${this.id}/places/`, v)
        .then(() => {
          this.handleGetData()
          this.editedItem = null
        })
    },
    async handleGetData () {
      try {
        if (!this.id) return
        apiService.getAllWithoutLimit('dviewcontent', `v1/system/activity-barcelo-01/${this.id}/places`)
          .then(response => {
            response = response.map(item => {
              item.Name = item.Name ? JSON.parse(item.Name) : null
              return item
            })
            this.values = response
          })
      } catch (error) {
        console.log(error)
      }
    },
    async handleSave () {
      this.editedItem.ContentTypeID = this.id
      this.editedItem.WorkspaceID = this.workspaceID
      if (this.editedItem.ID) {
        await new Promise((resolve) => apiService.updateItem('dviewcontent', `v1/system/activity-barcelo-01/${this.id}/places/`, this.editedItem.ID, this.editedItem)
          .then(() => {
            resolve()
          }))
      } else {
        await new Promise((resolve) => apiService.addItem('dviewcontent', `v1/system/activity-barcelo-01/${this.id}/places`, this.editedItem)
          .then(() => {
            resolve()
          }))
      }

      this.handleGetData()
      this.editedItem = null
    },
    handleChangeIsModified () {

    },
  },
}
</script>



